import { render } from "./DatabaseConfigDialog.vue?vue&type=template&id=4fa7be3d&scoped=true"
import script from "./DatabaseConfigDialog.vue?vue&type=script&lang=js"
export * from "./DatabaseConfigDialog.vue?vue&type=script&lang=js"

import "./DatabaseConfigDialog.vue?vue&type=style&index=0&id=4fa7be3d&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa7be3d"]])

export default __exports__